// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Eoa3","label":"SetPasswdForm_label__1H_aR"};